// Be sure to pretend we are in a non-ADM compatible environment

// we do not ACTUALLY need jquery ui in order to define the widgetfn,
// but there appears to be a load order issue without including it here
// UPDATE: looks like the issue is that IF jquery-ui is included in the packed js,
// then we need jquery.ui.widget.js to be included AFTER it, otherwise $.widget gets overridden as
// a lower version. 
// If there is no jquery-ui, then this widget works fine, 
// so we should probably move jquery-ui out of this module at some point
require('jquery-ui');
require('!!imports-loader?define=>undefined!jq_file_upload/js/vendor/jquery.ui.widget.js');
require('!!imports-loader?define=>undefined!jq_file_upload/js/jquery.iframe-transport.js');
require('!!imports-loader?define=>undefined!js_load_image/load-image.min.js');
require('!!imports-loader?define=>undefined!jq_file_upload/js/jquery.fileupload.js');
require('./file_uploader.js');